export enum AlertType {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger'
}
